"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _vuex = require("vuex");

var _listSecteurActMultiple = _interopRequireDefault(require("@/components/listSecteurActMultiple"));

var _listClientMultiple = _interopRequireDefault(require("@/components/listClientMultiple"));

var _listEnseigneMultiple = _interopRequireDefault(require("@/components/listEnseigneMultiple"));

var _listSecteurGeoMultiple = _interopRequireDefault(require("@/components/listSecteurGeoMultiple"));

var _listCascaderUtilisateur = _interopRequireDefault(require("@/components/listCascaderUtilisateur"));

var _tableau = _interopRequireDefault(require("./tableau"));

var _recap = _interopRequireDefault(require("./recap"));

var apiAffaire = _interopRequireWildcard(require("@/api/affaire"));

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

var _moment = _interopRequireDefault(require("moment"));

var _utils = require("@/helpers/utils");

var _exportModuleMixin = _interopRequireDefault(require("@/mixins/exportModuleMixin"));

var _exportListMixin = _interopRequireDefault(require("@/mixins/exportListMixin"));

var Excel = _interopRequireWildcard(require("exceljs"));

var _fileSaver = require("file-saver");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  name: 'Rapport-ArretsComptablesDI',
  mixins: [_exportModuleMixin.default, _exportListMixin.default],
  components: {
    listSecteurActMultiple: _listSecteurActMultiple.default,
    listClientMultiple: _listClientMultiple.default,
    listEnseigneMultiple: _listEnseigneMultiple.default,
    listSecteurGeoMultiple: _listSecteurGeoMultiple.default,
    listCascaderUtilisateur: _listCascaderUtilisateur.default,
    tableau: _tableau.default,
    recap: _recap.default
  },
  data: function data() {
    var _this = this;

    var validDate = function validDate(rule, value, callback) {
      var d = _this.date || '';

      if (d === '') {
        callback(new Error('Champ obligatoire'));
      }

      if (d !== '' && !(0, _moment.default)(d, 'YYYY').isValid()) {
        callback(new Error('Date invalide'));
      }

      callback();
    };

    return {
      show: false,
      refresh: 0,
      refreshRapport: 0,
      refreshEnseigne: 0,
      formData: {},
      // ---
      rules: {
        date: {
          required: true,
          validator: validDate
        }
      },
      rptData: [],
      totData: [],
      // ---
      listStatus: [{
        label: 'Tout',
        value: 'not in (\'\')'
      }, {
        label: 'En cours',
        value: 'not in (' + [CONST.AFFAIRE.STATUS.SLEEPING.value, CONST.AFFAIRE.STATUS.ARCHIVED.value].join(',') + ')'
      }, {
        label: 'En sommeil',
        value: 'in (' + CONST.AFFAIRE.STATUS.SLEEPING.value + ')'
      }, {
        label: 'Archivé',
        value: 'in (' + CONST.AFFAIRE.STATUS.ARCHIVED.value + ')'
      }],
      // ---
      secteursact: [],
      clients: [],
      enseignes: [],
      secteursgeo: [],
      conducteur: [],
      status: [],
      date: null
    };
  },
  beforeMount: function beforeMount() {
    this.mixinEvents = {
      export: "RAPPORT_ARRETS_CPTABLES_EXPORT",
      exported: "RAPPORT_ARRETS_CPTABLES_EXPORTED"
    };
  },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.initData();

            case 2:
              _context.next = 4;
              return this.validateForm();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['user']), {
    currentYear: function currentYear() {
      return (0, _moment.default)().format('YYYY');
    },
    YYYY: function YYYY() {
      return Number(this.date);
    }
  }),
  methods: _objectSpread({}, (0, _vuex.mapActions)('selections', ['updateFormData', 'loadFormData']), {
    initData: function () {
      var _initData = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var savedData;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.loadFormData("".concat(this.user.id_societe, "-").concat(this.$route.name));

              case 2:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 5;
                  break;
                }

                _context2.t0 = {};

              case 5:
                savedData = _context2.t0;

                if (savedData) {
                  this.secteursact = savedData.secteursact || [];
                  this.clients = savedData.clients || [];
                  this.enseignes = savedData.enseignes || [];
                  this.secteursgeo = savedData.secteursgeo || [];
                  this.conducteur = savedData.conducteur || null;
                  this.status = savedData.status || null;
                  this.etape = savedData.etape || CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value;
                  this.date = savedData.date || null;
                } // --------------------------------------------


                if (!this.date) {
                  this.date = this.currentYear;
                }

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function initData() {
        return _initData.apply(this, arguments);
      }

      return initData;
    }(),
    resetForm: function resetForm() {
      this.$refs['ElForm'].resetFields(); // ---

      this.rptData = [];
      this.totData = []; // ----

      this.secteursact = [];
      this.clients = [];
      this.enseignes = [];
      this.secteursgeo = [];
      this.conducteur = null;
      this.status = [];
      this.date = this.currentYear;
      this.show = false;
      this.refresh++;
    },
    getAllRptData: function () {
      var _getAllRptData = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var _this2 = this;

        var Y, YYYYplus1, results1, results2, results3, _loop, index, data;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.show = false;
                this.$loader(true);
                this.rptData = [];
                this.totData = [];
                Y = this.YYYY;
                YYYYplus1 = Number(this.YYYY) + 1;
                _context3.next = 8;
                return this.getRptData("".concat(Y, "01"), "".concat(Y, "05"));

              case 8:
                results1 = _context3.sent;
                _context3.next = 11;
                return this.getRptData("".concat(Y, "05"), "".concat(Y, "09"));

              case 11:
                results2 = _context3.sent;
                _context3.next = 14;
                return this.getRptData("".concat(Y, "09"), "".concat(YYYYplus1, "01"));

              case 14:
                results3 = _context3.sent;
                // 202509 < periode_gestmens <= 202601
                results1.forEach(function (row) {
                  var data = row;
                  data.Colonne1 = row.mtDepensesComptabilisees;
                  data.Total = row.mtDepensesComptabilisees;

                  _this2.rptData.push(data);
                });
                results2.forEach(function (row) {
                  var index = _this2.rptData.findIndex(function (x) {
                    return x.id === row.id && x.designationDI === row.designationDI;
                  });

                  if (index === -1) {
                    var _data = row;
                    _data.Colonne2 = row.mtDepensesComptabilisees;
                    _data.Total = row.mtDepensesComptabilisees;

                    _this2.rptData.push(_data);
                  } else {
                    _this2.rptData[index].Colonne2 = row.mtDepensesComptabilisees;
                    _this2.rptData[index].Total += row.mtDepensesComptabilisees;
                  }
                });
                results3.forEach(function (row) {
                  var index = _this2.rptData.findIndex(function (x) {
                    return x.id === row.id && x.designationDI === row.designationDI;
                  });

                  if (index === -1) {
                    var _data2 = row;
                    _data2.Colonne3 = row.mtDepensesComptabilisees;
                    _data2.Total = row.mtDepensesComptabilisees;

                    _this2.rptData.push(_data2);
                  } else {
                    _this2.rptData[index].Colonne3 = row.mtDepensesComptabilisees;
                    _this2.rptData[index].Total += row.mtDepensesComptabilisees;
                  }
                }); // calculs des totaux en bas de page

                _loop = function _loop(index) {
                  var designationDI = _this2.rptData[index].designationDI;
                  var Colonne1 = _this2.rptData[index].Colonne1 ? _this2.rptData[index].Colonne1 : null;
                  var Colonne2 = _this2.rptData[index].Colonne2 ? _this2.rptData[index].Colonne2 : null;
                  var Colonne3 = _this2.rptData[index].Colonne3 ? _this2.rptData[index].Colonne3 : null;
                  var Total = _this2.rptData[index].Total ? _this2.rptData[index].Total : null;

                  var indexOf = _this2.totData.findIndex(function (x) {
                    return x.designationDI === _this2.rptData[index].designationDI;
                  });

                  if (indexOf === -1) {
                    var row = {};
                    row.designationDI = designationDI;
                    row.Colonne1 = Colonne1;
                    row.Colonne2 = Colonne2;
                    row.Colonne3 = Colonne3;
                    row.Total = Total;

                    _this2.totData.push(row);
                  } else {
                    if (Colonne1) _this2.totData[indexOf].Colonne1 += Colonne1;
                    if (Colonne2) _this2.totData[indexOf].Colonne2 += Colonne2;
                    if (Colonne3) _this2.totData[indexOf].Colonne3 += Colonne3;
                    if (Total) _this2.totData[indexOf].Total += Total;
                  }
                };

                for (index in this.rptData) {
                  _loop(index);
                }

                this.show = true;
                this.refresh++;
                this.refreshRapport++;
                this.$loader(false); // sauvegarde les filtres dans le localStorage

                data = {
                  etape: CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value,
                  secteursact: this.secteursact,
                  clients: this.clients,
                  enseignes: this.enseignes,
                  secteursgeo: this.secteursgeo,
                  conducteur: this.conducteur ? this.conducteur.id : null,
                  status: this.status,
                  id_societe: this.user.id_societe,
                  date: this.date
                };
                this.updateFormData({
                  pageKey: "".concat(this.user.id_societe, "-").concat(this.$route.name),
                  data: data
                });

              case 26:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getAllRptData() {
        return _getAllRptData.apply(this, arguments);
      }

      return getAllRptData;
    }(),
    validateForm: function validateForm() {
      var _this3 = this;

      this.$refs['ElForm'].validate(function (valid) {
        if (valid) {
          /*
          console.log('-------------------------------------')
          console.log('secteursact', this.secteursact)
          console.log('clients', this.clients)
          console.log('enseignes', this.enseignes)
          console.log('secteursgeo', this.secteursgeo)
          console.log('conducteur', this.conducteur)
          console.log('etape, status', CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value, this.status)
          console.log('date', this.date)
          */
          _this3.getAllRptData();
        }
      });
    },
    getRptData: function getRptData(minBorne, maxBorne) {
      var _this4 = this;

      return new Promise(function (resolve) {
        var data = {
          etape: CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value,
          secteursact: _this4.secteursact,
          clients: _this4.clients,
          enseignes: _this4.enseignes,
          secteursgeo: _this4.secteursgeo,
          conducteur: _this4.conducteur ? _this4.conducteur.id : null,
          status: _this4.status,
          debBorne: minBorne,
          finBorne: maxBorne,
          id_societe: _this4.user.id_societe
        };
        apiAffaire.rptDeboursesIndirects(data).then(function (results) {
          resolve(results.rptData);
        });
      });
    },
    // ==================
    // Export excel
    // ==================
    generateExcelFile: function () {
      var _generateExcelFile = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var workbook, title, style, worksheet, columnHeaderList, cellStart, cellEnd, rowCount, buffer, now, fileType, fileName, fileExtension, file, blob;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // Classeur Excel
                workbook = new Excel.Workbook();
                title = 'Arrêtés Comptables DI ' + this.date; // Style et formatage génériques

                style = {
                  // en-tête
                  header: {
                    font: {
                      bold: true,
                      color: {
                        argb: 'FF000000'
                      }
                    },
                    fill: {
                      type: 'pattern',
                      pattern: 'solid',
                      fgColor: {
                        argb: 'FFa4c8ff'
                      }
                    },
                    alignment: {
                      vertical: 'center',
                      horizontal: 'center'
                    },
                    border: {
                      top: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      },
                      left: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      },
                      bottom: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      },
                      right: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      }
                    }
                  },
                  // ligne des totaux
                  totaux: {
                    font: {
                      bold: true,
                      color: {
                        argb: 'FF000000'
                      }
                    },
                    fill: {
                      type: 'pattern',
                      pattern: 'solid',
                      fgColor: {
                        argb: 'FFf5f7fa'
                      }
                    },
                    alignment: {
                      vertical: 'center',
                      horizontal: 'right'
                    },
                    border: {
                      top: {
                        style: 'thin',
                        color: {
                          argb: 'FF000000'
                        }
                      },
                      left: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      },
                      bottom: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      },
                      right: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      }
                    }
                  },
                  // lignes impaires
                  odd: {
                    font: {
                      color: {
                        argb: 'FF000000'
                      }
                    },
                    fill: {
                      type: 'pattern',
                      pattern: 'solid',
                      fgColor: {
                        argb: 'FFDDDDDD'
                      }
                    }
                  },
                  // lignes paires
                  even: {
                    font: {
                      color: {
                        argb: 'FF000000'
                      }
                    }
                  }
                }; // Propriétés du classeur

                workbook.creator = 'Groupe MARRAUD - EASY';
                workbook.lastModifiedBy = 'Groupe MARRAUD - EASY'; // workbook.lastPrinted = ''

                workbook.created = new Date();
                workbook.company = 'Groupe MARRAUD';
                workbook.manager = '';
                workbook.title = "Export ".concat(title);
                workbook.subject = '';
                workbook.keywords = this.manager;
                workbook.category = '';
                workbook.description = "Rapport : ".concat(title); // Forcer les calculs au chargement du classeur

                workbook.calcProperties.fullCalcOnLoad = true; // Feuille de calcul avec en-tête et pied de page

                worksheet = workbook.addWorksheet(title, {
                  properties: {
                    defaultRowHeight: 15
                  },
                  headerFooter: {
                    firstHeader: 'Groupe MARRAUD - EASYs - &A',
                    firstFooter: '&L&D à &T&C&F&RPage &P sur &N'
                  },
                  views: [// Viger les volets apres la 2ieme ligne
                  {
                    state: 'frozen',
                    xSplit: 0,
                    ySplit: 2
                  }]
                }); // Add column headers and define column keys and widths
                // Note: these column structures are a workbook-building convenience only,
                // apart from the column width, they will not be fully persisted.
                // Recherche des entetes colonnes d'en-tête

                columnHeaderList = this.getColumnHeaderList(); // Ajout des entetes de colonnes sur la 1ere lignes (colonnes fusionnées)

                cellStart = 0;
                cellEnd = 0; // --

                cellStart = this.getFirstColumnHeaderByGroup(columnHeaderList, 'avril');
                cellEnd = this.getLastColumnHeaderByGroup(columnHeaderList, 'avril');

                if (cellStart && cellEnd) {
                  worksheet.mergeCells("".concat(cellStart.c, "1:").concat(cellEnd.c, "1"));
                  worksheet.getCell("".concat(cellStart.c, "1")).value = 'Avril ' + this.date;
                } // --


                cellStart = this.getFirstColumnHeaderByGroup(columnHeaderList, 'aout');
                cellEnd = this.getLastColumnHeaderByGroup(columnHeaderList, 'aout');

                if (cellStart && cellEnd) {
                  worksheet.mergeCells("".concat(cellStart.c, "1:").concat(cellEnd.c, "1"));
                  worksheet.getCell("".concat(cellStart.c, "1")).value = 'Août ' + this.date;
                } // --


                cellStart = this.getFirstColumnHeaderByGroup(columnHeaderList, 'decembre');
                cellEnd = this.getLastColumnHeaderByGroup(columnHeaderList, 'decembre');

                if (cellStart && cellEnd) {
                  worksheet.mergeCells("".concat(cellStart.c, "1:").concat(cellEnd.c, "1"));
                  worksheet.getCell("".concat(cellStart.c, "1")).value = 'Décembre ' + this.date;
                } // --


                cellStart = this.getFirstColumnHeaderByGroup(columnHeaderList, 'total');
                cellEnd = this.getLastColumnHeaderByGroup(columnHeaderList, 'total');

                if (cellStart && cellEnd) {
                  worksheet.mergeCells("".concat(cellStart.c, "1:").concat(cellEnd.c, "1"));
                  worksheet.getCell("".concat(cellStart.c, "1")).value = ' ';
                } // ajout des entetes de colonnes sur la 2ieme lignes


                worksheet.getRow(2).values = columnHeaderList.map(function (x) {
                  return x.header;
                }); // Définition des colonnes d'en-tête

                worksheet.columns = columnHeaderList.map(function (x) {
                  return {
                    key: x.key,
                    width: x.width
                  };
                }); // Ajout filtres automatiques sur la 2ieme lignes, colonne 1 et 2

                worksheet.autoFilter = 'A2:B2'; // Données

                worksheet.addRows(this.getPreparedDataForExport()); // Totaux sur la derniere ligne

                rowCount = worksheet.rowCount + 1;
                worksheet.getCell("A".concat(rowCount)).style = _objectSpread({}, style.totaux);
                worksheet.getCell("B".concat(rowCount)).style = _objectSpread({}, style.totaux);
                worksheet.getCell("C".concat(rowCount)).value = {
                  formula: "SUBTOTAL(9,C3:C".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("C".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux);
                worksheet.getCell("D".concat(rowCount)).value = {
                  formula: "SUBTOTAL(9,D3:D".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("D".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux);
                worksheet.getCell("E".concat(rowCount)).value = {
                  formula: "SUBTOTAL(9,E3:E".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("E".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux);
                worksheet.getCell("F".concat(rowCount)).value = {
                  formula: "SUBTOTAL(9,F3:F".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("F".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux); // Boucle sur les lignes de la feuille du classeur

                worksheet.eachRow(function (row, rowNumber) {
                  // Boucle sur les cellules de la ligne
                  row.eachCell({
                    includeEmpty: true
                  }, function (cell, colNumber) {
                    switch (rowNumber) {
                      // Lignes d'en-tête
                      case 1: // ligne 1

                      case 2:
                        // ligne 2
                        cell.style = _objectSpread({}, style.header);
                        break;
                      // Données

                      default:
                        var columnStyle = columnHeaderList[colNumber - 1].style || {};
                        var cellStyle = {}; // Lignes paires

                        if (rowNumber % 2 === 0) {
                          cellStyle = _objectSpread({}, style.even);
                        } else {
                          cellStyle = _objectSpread({}, style.odd);
                        }

                        cell.style = Object.assign({}, cell.style, columnStyle, cellStyle);
                        break;
                    }
                  });
                }); // Ecriture dans un nouveau buffer

                _context4.next = 48;
                return workbook.xlsx.writeBuffer();

              case 48:
                buffer = _context4.sent;
                // Paramètres du fichier généré dynamiquement
                now = (0, _utils.getDateNow)().format('YYYYMMDD-HHmmss'); // const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'

                fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                fileName = 'Rapport-Arretes-Comptables-DI-' + this.date;
                fileExtension = 'xlsx';
                file = "".concat(now, "-").concat(fileName, ".").concat(fileExtension); // Création du Blob

                blob = new Blob([buffer], {
                  type: fileType
                }); // Servir le fichier via le navigateur client

                (0, _fileSaver.saveAs)(blob, file);

              case 56:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function generateExcelFile() {
        return _generateExcelFile.apply(this, arguments);
      }

      return generateExcelFile;
    }(),
    getColumnHeaderList: function getColumnHeaderList() {
      var defaultStyles = {
        texte: {
          alignment: {
            vertical: 'top'
          }
        },
        monetaire: {
          numFmt: '# ### ##0.00 "€"',
          alignment: {
            vertical: 'top',
            horizontal: 'right'
          }
        },
        pourcentage: {
          numFmt: '##0.00 %',
          alignment: {
            vertical: 'top',
            horizontal: 'right'
          }
        },
        date: {
          numFmt: 'dd/mm/yyyy',
          alignment: {
            vertical: 'top',
            horizontal: 'center'
          }
        },
        nombre: {
          numFmt: '0',
          alignment: {
            vertical: 'top',
            horizontal: 'right'
          }
        }
      }; // Colonnes d'en-tête

      var columnHeaderList = [// Affaire
      {
        header: 'N° Affaire',
        key: 'num_affaire',
        width: 30,
        style: defaultStyles.texte
      }, {
        header: 'Désignation DI',
        key: 'designationDI',
        width: 30,
        style: defaultStyles.texte
      }, {
        header: 'Cumulé 01 à 04',
        group: 'avril',
        key: 'Colonne1',
        width: 15,
        style: defaultStyles.monetaire
      }, {
        header: 'Cumulé 05 à 08',
        group: 'aout',
        key: 'Colonne2',
        width: 15,
        style: defaultStyles.monetaire
      }, {
        header: 'Cumulé 09 à 12',
        group: 'decembre',
        key: 'Colonne3',
        width: 15,
        style: defaultStyles.monetaire
      }, {
        header: 'Total ' + this.date,
        group: 'total',
        key: 'Total',
        width: 15,
        style: defaultStyles.monetaire
      }];
      var columnName = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
      columnHeaderList.forEach(function (x, index) {
        x.c = columnName[index];
        x.position = index + 1;
      });
      return columnHeaderList;
    },
    getFirstColumnHeaderByGroup: function getFirstColumnHeaderByGroup() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var groupName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var cells = data.filter(function (x) {
        return x.group === groupName;
      });

      if (cells.length > 0) {
        return cells.reduce(function (accumulator, x) {
          // console.log(`x.position = ${x.position}`, 'accumulator', accumulator, typeof accumulator)
          return x.position < accumulator.position ? x : accumulator;
        }, cells[0]);
      }
    },
    getLastColumnHeaderByGroup: function getLastColumnHeaderByGroup() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var groupName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var cells = data.filter(function (x) {
        return x.group === groupName;
      });

      if (cells.length > 0) {
        return cells.reduce(function (accumulator, x) {
          // console.log(`x.position = ${x.position}`, 'accumulator', accumulator, typeof accumulator)
          return x.position > accumulator.position ? x : accumulator;
        }, cells[0]);
      }
    },
    getPreparedDataForExport: function getPreparedDataForExport() {
      // On utilise les données pré-filtrées par le dataTable
      return this.rptData;
    }
  })
};
exports.default = _default;